import { z } from 'zod';
export const SearchSchema = z.object({
  /** 表示中のデータのバージョン（Task ID）。未指定なら最新バージョンを表示する。 */
  versionId: z.string().optional()
});